import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Config from "config";
import PdfPreview from "./pdfPreview";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentInvestissement";
import ImpressionCard from "components/Common/ImpressionCard";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";

const ApercuFacture = () => {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [factureData, setFactureData] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const handleSignAction = async (action) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const donnee = await response.json();
      if (response.status == 200) {
        toast.success(donnee.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(
          "La requête a échoué avec le statut " + response.status
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleSendMailAction = async (action) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action.controlleur}/${id}/${action.action}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const donnee = await response.json();
      if (response.status == 200) {
        toast.success(donnee.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(
          "La requête a échoué avec le statut " + response.status
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Facture | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          ></NavLink>
        </NavItem>
      </Nav>
    );
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_paiements/${id}/apercu_facture`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const factureData = await response.json();
        setFactureData(factureData);

        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={`${backUrl}/fx_paiements/list`}
                            style={{
                              color: "#555B21",
                              textDecoration: "underline !important",
                            }}
                          >
                            Factures
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        factureData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <Link
                        to={`${backUrl}/fx_paiements/${id}/edit`}
                        state={linkState}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="bx bx-edit-alt"></i>Modifier
                      </Link>
                      {factureData?.actions?.length > 0
                        ? factureData?.actions.map((value, index) =>
                            value.action.action == "download_signed" ? (
                              <>
                                &nbsp; &nbsp;
                                <Link
                                  to={factureData?.link}
                                  className="btn btn-sm btn-warning"
                                >
                                  <i className="bx bx-download"></i>
                                  {value.label}
                                </Link>
                              </>
                            ) : value.action.action == "signer" ? (
                              <>
                                &nbsp; &nbsp;
                                <Link
                                  to="#"
                                  className="btn btn-sm btn-success"
                                  onClick={() => handleSignAction(value.action)}
                                >
                                  <i className="bx bx-check-double"></i>
                                  {value.label}
                                </Link>
                              </>
                            ) : value.action.action == "send_mail" ? (
                              <>
                                &nbsp; &nbsp;
                                <Link
                                  to="#"
                                  className="btn btn-sm btn-success"
                                  onClick={() =>
                                    handleSendMailAction(value.action)
                                  }
                                >
                                  <i class="bx bx-mail-send"></i>
                                  {value.label}
                                </Link>
                              </>
                            ) : null
                          )
                        : null}
                    </div>
                  </div>
                </CardBody>

                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col
                              sm="12"
                              className="d-flex justify-content-center align-items-center"
                            >
                              <PdfPreview pdfUrl={factureData?.link} />
                            </Col>

                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default ApercuFacture;
